import { render } from "./PaymentSlipDetail.vue?vue&type=template&id=72fd01f6&scoped=true"
import script from "./PaymentSlipDetail.vue?vue&type=script&lang=ts"
export * from "./PaymentSlipDetail.vue?vue&type=script&lang=ts"

import "./PaymentSlipDetail.vue?vue&type=style&index=0&id=72fd01f6&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-72fd01f6"

export default script